
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/set-geofence",
      function () {
        return require("private-next-pages/android/local/set-geofence/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/set-geofence"])
      });
    }
  